import { theme } from "../../theme";
export const genericList = {
    root: {
      width: "45%",
      height: "100%",
      position: "relative",
      textAlign: "center",
      "&.assignReservation":{
        "& .MuiListItemText-root":{
          maxWidth:"350px",
        },
      },
    },
    listWrapper: {
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
      borderRadius: "5px",
      height: "100%",
    },
    bulkActionButton: {
      borderRadius: "12px",
      height: "25px",
      whiteSpace: "nowrap",
      fontWeight: "bold",
      marginRight: "20px",
      "&:hover": {},
    },
    customActionButton: {
      borderRadius: "12px",
      height: "25px",
      whiteSpace: "nowrap",
      fontWeight: "bold",
      marginLeft: "20px",
    },
    loading: {
      marginTop: "20px",
      marginBottom: "20px",
    },
    bulkActions: {
      height: "60px",
      backgroundColor: theme.palette.grey[500],
      color: "#fff",
      fontSize: "18px",
      padding: "0 16px",
      position: "absolute",
      top: "-60px",
      left: 0,
      right: 0,
      zIndex: 11,
      display: "flex",
      alignItems: "center",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
    },
    hasBulkActionsBar: {
      marginTop: "60px", // the height of the bulk actions bar
      height: "calc(100% - 60px)",
    },
  } as const;